<template>

  <div class="atividades-lavadorlancamentos ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="3">
                <label for="select-rfi-empresa">Empresa</label> 
                <multiselect  id="selecao-empresa-cor"  v-model="valor_empresa"                   
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="nomeempresarial" track-by="nomeempresarial" name="nomeempresarial"              >                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="3">
                <label for="select-rfi-filial">Filial</label> 
                <multiselect id="selecao-filial-cor"  v-model="valor_filial"                    
                  :options="filiais" 
                  :multiple="true"   
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2">
                   <label for="select-status">Tipo de lavagem</label> 

                <multiselect id="selecao-status-lav" v-model="value_lavagem"  required
                :options="tplavagens" 
                :multiple="true"                 
                :close-on-select="false" 
                :clear-on-select="false" 
                :preserve-search="true" placeholder="Status" label="lavagem" track-by="lavagem" name="lavagem"
                :preselect-first="true">
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} status selecionado</span></template>
                </multiselect>                
              </b-col> 

              <b-col cols="2">
                <label for="select-status">Status</label> 
                
                <multiselect id="selecao-status-lav" v-model="value_status"  required
                :options="statuss" 
                :multiple="true"         
                @close="loadLavagens()"         
                :close-on-select="false" 
                :clear-on-select="false" 
                :preserve-search="true" placeholder="Status" label="status" track-by="status" name="status"
                :preselect-first="true">
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} status selecionado</span></template>
                </multiselect>     


                

              </b-col>




<!--
              <b-col cols="2">
                <br>                 
                <b-button variant="primary" class="mt-2 mp-2"  @click="loadLavagens()">
                   Pesquisar
                </b-button>                      
              </b-col>
-->
                <b-col cols="1">
                <br>                 
                <b-button variant="primary" class="mt-2 mp-2" v-b-modal.modal-multi-1 block @click="loadTipoLavagem()" >
                   Novo
                </b-button>                      
              </b-col>

                            <b-col>
                <br>                
                <b-button size="sm" variant="success" class="mr-2 mt-2" block @click="carregando = true,gerarPlanilha()">
                  Gerar planilha
                </b-button>                      
              </b-col>
			  


          </b-row>
          <b-row>
            
              <b-col>
                <div >       
                <b-progress class="mt-3 mp-3" :max="barra_limite">
                  <b-progress-bar variant="success"  :value="barra_inicial" :label="`${((barra_inicial / barra_limite) * 100).toFixed(2)} %`"></b-progress-bar>
                </b-progress>
                </div>
              </b-col>
            
          </b-row>
    </b-form>
    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    
    <!--tbl de dados -->
    <b-table id="id-lavagens"  small hover striped sticky-header="762px"  :items="lavagens" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="loadCarregaLavagem(data.item),postLavagem()"    title="Encerrar"  size="sm" variant="success" class="mr-2 mt-2">                
            <i class="fa fa-check"></i>              
          </b-button> 

          <b-button  @click="loadCarregaLavagem(data.item),loadTipoLavagem()"    title="Editar lavagem"  size="sm" variant="warning" class="mr-2 mt-2" v-b-modal.modal-multi-1>                
            <i class="fa fa-pencil"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="modal-multi-1" cancel-title="Fechar" ok-title="Gravar"  hide-footer centered size="xl" :title="`Lavagem Nº.: ${ lavagem.id == null ? '-' :lavagem.id }`" no-close-on-esc no-close-on-backdrop  >
          <!-- -->
          <div>

            

            <b-row>
              <input  id="id-lav-carro" type="hidden" v-model="lavagem.id" />              
              <b-col cols="2">
                <label for="input-lav-live">Carro</label> 
                <b-form-input id="carro-lav-" v-model="lavagem.prefixo" readonly   placeholder="Nº do carro"></b-form-input>                                              
              </b-col>


            <b-col cols="5">
              <label for="input-lav-parecer">Tipo de Lavagem</label> 
              <div>                    
                <b-form-select   id="lav-parecer"               
                  v-model="lavagem.lavagem_id"  
                  :options="tplavagens"
                  class="mb-3"
                  text-field="lavagem"                            
                >                
                </b-form-select>
              </div>
            </b-col> 

                        <b-col cols="5">
              <label for="input-lav-parecer">Status</label> 
              <div>                    
                <b-form-select   id="lav-parecer"               
                  v-model="lavagem.status_id"  
                  :options="statuss"
                  class="mb-3"
                  text-field="status"                            
                >                
                </b-form-select>
              </div>
            </b-col> 
              
            </b-row> 


            <b-row>
              <b-col sm="2">
                <label for="textarea-small">Observações:</label>
                
              </b-col>
              <b-col sm="12">
                <b-form-textarea                   
                  id="id-lav-obs"
                  v-model="lavagem.observacoes"
                  size="sm"      
                  placeholder="Digite as observações"
                ></b-form-textarea>
              </b-col>
            </b-row> 

            <b-button class="mt-3" variant="success" block @click="postLavagem()">Gravar</b-button>
            
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import * as XLSX from 'xlsx'
import moment from 'moment'
import { mapState } from 'vuex' 


export default {    
    name: 'ManutencaoLavadorLancamento',    
        computed : { ... mapState (['user'],),
      itemsFiltered(){
        let valores = [];
       // const values = Object.values(obj);
        valores = this.rfilancamentos.filter((item) =>{
          return (
            item.carro.indexOf(this.search) >-1 
          );
        });
        return valores
        } ,
        
      
    } ,


    data: function() {
      
        return {            
            mode: 'save',

            empresas:[],
            filiais:[],
            tplavagens:[],// [] lista    
            tplavagensc:[],// [] lista    

            lavagem:{},
            lavagens:[],



            /////

            valor_empresa:[],
            valor_filial:[],
            value_status:[],// [] lista    
            value_lavagem:[],// [] lista    

            carregando: false,
            atualizando: false,            


            status:{},
            statuss: [],   // [] lista            

            
            
            barra_inicial: 0,                     
            barra_limite: 50000,
            
            fields: [
              { key: 'id', label: 'Nº', sortable: true },         
              { key: 'origem_id', label: 'Nº origem', sortable: true },      
              { key: 'origem_desc', label: 'Origem', sortable: true },     
              { key: 'empresa_id', label: 'Empresa', sortable: true },                 
              { key: 'filial_id', label: 'Filial', sortable: true },                 
              { key: 'dt_cadastro', label: 'Cadastrado', sortable: true, formatter: (value, key, lavagens) => {
                    return moment(lavagens.dt_cadastro).format('DD/MM/YYYY - HH:mm:ss').replace('Data inválida','-') ; }  },
              { key: 'id', label: 'Nº RFI', sortable: true },     
              { key: 'prefixo', label: 'Carro', sortable: true },                                                                          
                { key: 'lavagem', label: 'Tipo Lavagem', sortable: true },
                { key: 'status', label: 'Status', sortable: true },


             
                { key: 'observacoes', label: 'Observações', sortable: true },                               
                
                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect
    },
    methods: {

      showModalLancamento() {
        this.$refs['v-b-modal.modal-multi-1'].show()
      },

      //barra de progresso
      ready () {
      this.handle = setInterval(() =>{
        this.barra_inicial = this.barra_inicial + 1000
        if(this.barra_inicial >= this.barra_limite){
          this.barra_inicial = 0
          this.loadLavagens()
        }
      },1000)
      },

      gerarPlanilha() {
        // Objeto com os dados para a planilha
        const dados = this.lavagens

        // Cria uma nova planilha
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dados);

        // Adiciona a planilha ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Salva o workbook como arquivo
        XLSX.writeFile(workbook, 'LAVADOR.xlsx');
      },

      loadEmpresas() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.post(url,corpo).then(res => {
            this.empresas = res.data.map(emp => {              
              return { id_empresa: emp.id_empresa, nomeempresarial: emp.nomeempresarial }
            })
          })
      },  
      
      loadFiliais() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,corpo).then(res => {
            this.filiais = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }        
            })
          })
      },

      
      loadTipoLavagem() {
            let corpo = {                  
              "empresa_id": `${this.valor_empresa.map(e => e.id_empresa)}`,              
              "filial_id": `${this.valor_filial.map(e => e.id_filial_erp)}`              
            };
          const url = `${baseApiUrl}/manutencao/lavador/tipoLavagem`
          axios.post(url,corpo).then(res => {
            this.tplavagens = res.data.map(tpl => {              
               return { ... tpl, value: tpl.id, lavagem: tpl.lavagem }
            })
          })
      },

      loadStatus() {
          const url = `${baseApiUrl}/manutencao/lavador/status`
          axios.get(url).then(res => {
            this.statuss = res.data.map(tpl => {              
               return { ... tpl, value: tpl.id, status: tpl.status }
            })
          })
      },

      loadTipoLavagemCad() {
            let corpo = {                  
              "empresa_id": `${this.valor_empresa.map(e => e.id_empresa)}`,              
              "filial_id": `${this.valor_filial.map(e => e.id_filial_erp)}`              
            };
          const url = `${baseApiUrl}/manutencao/lavador/tipoLavagem`
          axios.post(url,corpo).then(res => {
            this.tplavagensc = res.data.map(sit => {                            
              return { ... tpl, value: tpl.id, lavagem: tpl.lavagem }            
            })
          })
      },


        loadCarros() {          
          const url = `${baseApiUrl}/despachante/carro/${this.lavagem.carro}`
          axios.get(url).then(res => { this.lavagem = res.data })          
        },        

        loadLavagens() {                        
          let corpo = {                  
              "empresa_id": `${this.valor_empresa.map(e => e.id_empresa)}`,              
              "id_empresa": `${this.user.id_empresa}`,                            
              "filial_id": `${this.valor_filial.map(e => e.id_filial_erp)}`,
              "status_id": `${this.value_status.map( l => l.id)}`,                
              "lavagem_id": `${this.value_lavagem.map(si => si.id)}`,                
          }; 

          const url = `${baseApiUrl}/manutencao/lavador/lancamentos`            
          axios.post(url,corpo)
              .then(res => { this.lavagens = res.data })        
              .catch(showError)           
          
               
        }, 


        
        loadCarregaLavagem(lavagem){
            this.lavagem = { ...lavagem }
        },

        
        
        postLavagem() {                        
            let corpo = {    
              //"empresa": `${[this.user.id_empresa]}`,  
             // "empresa_id": `${this.valor_empresa.map(e => e.id_empresa)}`,              
              //"filial_id": `${this.valor_filial.map(e => e.id_filial_erp)}`,
              "status_id": this.lavagem.status_id.length > 0 ?  `${this.lavagem.status_id}` : 2,      ///2
              "lavagem_id": this.lavagem.lavagem_id ?  `${this.lavagem.lavagem_id}` : '1',         //1-completa
              "id": `${this.lavagem.id}`,   
              "observacoes": this.lavagem.observacoes ?  `${this.lavagem.observacoes}` : '18',
              //"id_funcionario_alteracao": `${this.user.id_funcionario}`
            };

        const url = `${baseApiUrl}/manutencao/lavador`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadLavagens()
                    this.reset() //limpar os objetos valores
                })
                .catch(showError)
        },

        reset() {            
            this.lavagem = {}
            this.loadLavagens()
            //this.value_carro = ''            
        }
       
    },



    mounted() {   
      this.loadEmpresas()
      this.loadStatus()              
      this.loadTipoLavagem()
      this.loadLavagens()
      this.ready()       
      
      /*     
        
        this.loadCarregaLavagem()        
        this.loadCarros()  
        */
    },

}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>




</style>